import { log } from 'log';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { resetToDefault } from 'js/hooks/user/store/actions';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';
import { loginFailedPopupAction } from 'js/components/popups/LoginFailedPopup';

import { useLogout } from './useLogout';

export const useFailedLoginAction = () => {
    const logout = useLogout();
    const dispatch = useDispatch();

    return useCallback((error) => {
        const message = error?.data || error?.response?.data || 'Login error';
        const errorCode = error?.data?.errorCode || error?.response?.data?.errorCode;
        const codes = [
            23 // player is frozen
        ];

        if (error?.ssoLogin) {
            log('info', message);
            dispatch(resetToDefault());
            publicEventsAPIService.trigger('auth:generic_login:error', message);

            return;
        }

        if (codes.includes(errorCode)) {
            dispatch(loginFailedPopupAction({ errorCode }));
        } else {
            log('error', message);
        }

        publicEventsAPIService.trigger('auth:generic_login:error', message);

        logout();
    }, [logout, dispatch]);
};
